$mol_icon_view_column $mol_icon path \M16,5V18H21V5M4,18H9V5H4M10,18H15V5H10V18Z
